module.exports = __webpack_public_path__ + "img/icon_public_portal_applications.24c143cd.svg";